import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import React, { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
import { makeStyles } from "@material-ui/core";
import CardBody from "components/Card/CardBody";
import ConversionRate from "./ConversionRate";
import { useDispatch, useSelector } from "react-redux";
import { EMPLOYEE_CLIENT_ASSIGNED_CONVERTED_REQUESTED } from "redux/actions";
import { Box } from "@mui/system";
import MonthYearSelector from "components/MonthYearSelector/MonthYearSelector";

const useStyles = makeStyles(styles);

const ClientBarChart = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [data, setData] = React.useState([]);
  const employeeRanking = useSelector(
    (state) => state.user.employeeClientAssignedConverted
  );
  const [selectedMonth, setSelectedMonth] = React.useState("");
  const [selectedYear, setSelectedYear] = React.useState("");

  React.useMemo(() => {
    const mappedData = employeeRanking.map((data) => ({
      name: data.firstName,
      assigned: data.clientCount,
      converted: data.convertedCount,
    }));
    setData(mappedData);
  }, [employeeRanking]);

  useEffect(() => {
    const now = new Date();
    dispatch({
      type: EMPLOYEE_CLIENT_ASSIGNED_CONVERTED_REQUESTED,
      payload: {
        // from: new Date(now.getFullYear(), now.getMonth(), 1),
        // to: new Date(now.getFullYear(), now.getMonth() + 1, 0),
      },
    });
  }, []);

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      const now = new Date();
      const date = new Date(`${selectedYear}-${selectedMonth}-01`);
      dispatch({
        type: EMPLOYEE_CLIENT_ASSIGNED_CONVERTED_REQUESTED,
        payload: {
          from: date,
          to: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        },
      });
    }
  }, [selectedMonth, selectedYear]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Card>
          <CardHeader color="success" icon>
            <Box display="flex" gap="16px">
              <h4 className={classes.cardIconTitle}>
                Employee Total Client Assigned + Converted
              </h4>
              <MonthYearSelector
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                onMonthChange={setSelectedMonth}
                onYearChange={setSelectedYear}
              />
            </Box>
          </CardHeader>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              width={500}
              height={300}
              data={data}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="assigned" fill="#8884d8" />
              <Bar dataKey="converted" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card>
          {/* <CardHeader></CardHeader> */}
          <CardBody>
            <ConversionRate />
          </CardBody>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ClientBarChart;
